export const SDK_VERSION = '8.34.0';
